export default __webpack_public_path__ + "static/media/hybrid-back.5581ab49.jpg";